// @flow
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components';

import { colors } from '../../shared/styles';
import Button from '../shared/Button';
import TextInput from '../shared/forms/TextInput';

export const validate = (values: Object) => {
    const errors = {};

    if (!values.email || values.email.length < 1) {
        errors.email = 'Email is required';
    }

    if (!values.password || values.password.length < 1) {
        errors.password = 'Password is required';
    }

    return errors;
};

const StyledForm = styled.form`
    margin: 100px auto 0 auto;
    max-width: 600px;

    & h2 {
        font-weight: lighter;
        text-align: center;
    }

    & .form {
        background: ${colors.white};
        border: solid 1px ${colors.offWhite};
        border-radius: 4px;
        padding-bottom: 10px;
    }

    & .login-error {
        font-size: 14px;
        text-align: center;
        color: ${colors.error.default};
    }

    & button {
        display: block;
        margin: 0 auto;
    }
`;

const LoginForm = props => {
    const { loginError, handleSubmit, submitting } = props;

    return (
        <StyledForm onSubmit={handleSubmit}>
            <h2>Please Login</h2>

            <div className="form">
                <Field
                    name="email"
                    label="Email Address"
                    type="email"
                    component={TextInput}
                    disabled={submitting}
                />

                <Field
                    name="password"
                    label="Password"
                    type="password"
                    component={TextInput}
                    disabled={submitting}
                />

                {loginError &&
                    <p className="login-error">
                        The provided email address and/or password is either
                        incorrect or does not exist.
                    </p>}

                <Button type="submit" disabled={submitting}>
                    {submitting ? 'Loggin in...' : 'Login'}
                </Button>
            </div>
        </StyledForm>
    );
};

export default reduxForm({
    form: 'login',
    validate,
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/Login/LoginForm.js